import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import { getGetVendorQueryOptions } from "@/requests/gen/react-query/vendor";
import { RecentNotes } from "./-recent-notes";
import { VendorInfo } from "./-vendor-info";
import VendorWarehouseLookupTable from "./-vendor-warehouse-table";
import { WhatsAppChat } from "./-whats-app-chat";
import { VendorCrumbs } from "../-crumbs";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/_warehouse-360/vendor/$vendorId/",
)({
  loader: ({ context: { queryClient }, params: { vendorId } }) =>
    queryClient.ensureQueryData(getGetVendorQueryOptions(numericId(vendorId))),
  component: VendorDetails,
});

function VendorDetails() {
  const { vendorId } = Route.useParams();
  const vendorIdInt = numericId(vendorId);
  const {
    data: vendor,
    isLoading,
    refetch: refetchVendor,
  } = useSuspenseQuery(suspenseOptions(getGetVendorQueryOptions(vendorIdInt)));

  return (
    <div>
      <title>{`${vendor?.name} Vendor Details - Legrande Health Portal`}</title>
      <VendorCrumbs />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 grid-flow-row">
        {!isLoading && vendor && (
          <>
            <div className="flex flex-col gap-4 order-1">
              <VendorInfo vendor={vendor} />
              <div className="md:block">
                <WhatsAppChat />
              </div>
            </div>

            <div className="order-2">
              <RecentNotes vendor={vendor} refetch={refetchVendor} />
            </div>

            <div className="col-span-1 md:col-span-full order-3">
              <VendorWarehouseLookupTable
                warehouseVendors={vendor.warehouse_vendors}
                vendorId={vendor.vendor_id}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
